import { graphql } from 'src/gql';

export const GET_CLIENT_SIDEBAR_DATA = graphql(/* GraphQL */ `
  query ClientSidebarData($id: ID, $householdId: ID) {
    client(id: $id) {
      id
      numberOfTodoTasks
      enableTaxTab
      household(id: $householdId) {
        orionHouseholdId
        adviceOnly
        name
        hiddenPortalSurfaces
        users {
          lastName
          firstName
        }
        portfolios {
          id
          householdId
          name
          displayName
          isPersonal
          orionHouseholdId
        }
        clientPortalMessage {
          message
          createdAt
          primaryClientHasRead
          coClientHasRead
        }
      }
      user {
        isPrimaryClient
        role
      }
    }
  }
`);
